import {
    listViewStore,
    getTableItemRelation,
    getApplyConversationActionContext,
    getTableConversationRelation,
} from 'owa-mail-list-store';
import type RetentionTagType from 'owa-service/lib/contract/RetentionTagType';
import type { ClientItem, ActionSource } from 'owa-mail-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import isSelectedPolicyDifferentForItem from '../helpers/isSelectedPolicyDifferentForItem';
import {
    ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
    DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
} from './retentionPolicyConstants';
import {
    onRetentionTagForItemsChanged,
    onRetentionTagForConversationsChanged,
} from '../actions/internalActions';

export default function onAssignPolicy(
    retentionId: string,
    isArchivePolicyClicked: boolean,
    selectedRetentionTagType: RetentionTagType | null | RetentionTagType[],
    folderId: string,
    clientItem: ClientItem | undefined,
    actionSource: ActionSource
) {
    const tableViewId = listViewStore.selectedTableViewId;
    const tableView = listViewStore.tableViews.get(tableViewId);
    const selectedTags = Array.isArray(selectedRetentionTagType)
        ? selectedRetentionTagType
        : [selectedRetentionTagType];
    let isAnySelectedPolicyDifferent = false;
    selectedTags.forEach(currentTag => {
        isAnySelectedPolicyDifferent =
            isAnySelectedPolicyDifferent ||
            isSelectedPolicyDifferentForItem({
                retentionTag: currentTag,
                retentionId: retentionId,
                inheritSubMenuIdentifier: isArchivePolicyClicked
                    ? ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER
                    : DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
            });
    });

    if (!isAnySelectedPolicyDifferent) {
        return;
    }
    // Check if the action is done upon an item or conversation and act accordingly
    const isPolicyChangedForItem =
        actionSource == 'RPCSAOverflow' ||
        tableView.tableQuery.listViewType === ReactListViewType.Message;
    const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
    const mailboxInfo = getMailboxInfo(tableView);
    if (isPolicyChangedForItem) {
        const itemIds =
            actionSource == 'RPCSAOverflow'
                ? [clientItem?.ItemId.Id]
                : selectedRowKeys.map(
                      rowKey => getTableItemRelation(rowKey, tableView.id).clientId.Id
                  );
        onRetentionTagForItemsChanged(
            isArchivePolicyClicked,
            retentionId,
            itemIds,
            actionSource,
            mailboxInfo
        );
    } else {
        const conversationActionContexts = selectedRowKeys.map(rowKey =>
            getApplyConversationActionContext(rowKey, tableView.id)
        );
        const itemIds: string[] = selectedRowKeys.reduce((acc, rowKey) => {
            const tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);
            if (tableConversationRelation) {
                acc.push(...tableConversationRelation.itemIds);
            }
            return acc;
        }, []);
        onRetentionTagForConversationsChanged(
            isArchivePolicyClicked,
            retentionId,
            folderId,
            conversationActionContexts,
            itemIds,
            actionSource,
            mailboxInfo
        );
    }
}
